import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardContent,
  Button,
  Container,
  Grid,
  Typography,
  CardActions,
} from "@mui/material";
import {
  VEHICLE_SUPPLIER_CHECKLIST_FORMS,
} from "navigation/CONSTANTS";
import Header from "components/Header";
import TranslationProvider from "providers/TranslationProvider";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { updateLang } from "i18n";
import { styled } from "@mui/system";

const StyledMainCard = styled(Card)({
  border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderTopWidth: 10,
    borderTopColor: "#1976d2",
    marginTop: 10,
    borderRadius: 8,
})

function VehicleCheckListFormSuccess() {
  const history = useHistory();

  const onSubmit = () => {
    history.push(VEHICLE_SUPPLIER_CHECKLIST_FORMS);
  };
  const { version } = useSelector((state) => state.translation.i18n);
  if (version && version > 1) {
    updateLang();
  }
  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);
  useEffect(() => {
    document.title = "Vehicle CheckList Supplier Form Success";
  });
  const { t, i18n } = useTranslation();
  return (
    <>
      <Container maxWidth="sm" disableGutters>
        <Grid container direction="column" alignItems="stretch" spacing={0}>
          <Grid item>
            <TranslationProvider />
            <Header />
            <StyledMainCard>
              <CardContent>
                <Typography variant="h6" gutterBottom color="textPrimary">
                  {t("other.lblSuccessSubmit")}
                </Typography>
                <Typography variant="body" gutterBottom color="textPrimary">
                  <b>
                    {" "}
                    {t("other.lblThankYou")}, {t("other.lblSentinelThankYou")}{" "}
                  </b>
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="medium" color="primary" onClick={onSubmit}>
                  {t("other.lblSubmitAnotherForm")}
                </Button>
              </CardActions>
            </StyledMainCard>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default VehicleCheckListFormSuccess;
